import { AxiosError, AxiosInstance } from 'axios'
import { captureException } from '@sentry/nextjs'
import { logger } from 'src/configs/logger'

type Props = {
  instance: AxiosInstance
  endpoint: string
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE'
  data?: object
  params?: object
}

export const httpRequest = async <ResponseType>({
  instance,
  endpoint,
  method = 'GET',
  data,
  params,
}: Props) => {
  try {
    const start = new Date().getTime()

    const response = await instance<ResponseType>(endpoint, {
      method,
      data,
      params,
    })

    const end = new Date().getTime()

    logger.info(
      `${method} ${endpoint} ${end - start}ms Status: ${response.status}`
    )

    return {
      data: response.data,
      status: response.status,
    }
  } catch (error) {
    const err = error as AxiosError<{ message: string }>
    const status = err.response?.status ?? 500

    logger.error(err.message, { payload: data, error })
    if (status > 499) captureException(error)

    return {
      error: err.response?.data.message ?? err.message,
      status,
    }
  }
}
